<template>
  <div class="about">
    <iframe
        :src="`./about.html`"
        width="100%"
        height="720px"
        ref="iframeDom"
        frameborder="0"
    ></iframe>

  </div>
</template>

<script>
    // 使用命名空间之后的简化方式
    import {createNamespacedHelpers } from "vuex";
    const { mapState, mapMutations } = createNamespacedHelpers('nav');
    export default {
        name: "About",
        created(){
            // TODO 1.被创建时指定当前导航栏类型为无搜索框
            this.typeUpdate(3);
        },
        methods:{
            ...mapMutations(['typeUpdate'])
        },
        mounted() {
            this.showSessionId = window.location.search;
            this.src = `/static/about.html${this.showSessionId}`
        },
        data(){
            return {
                // 我的外部文件是temp.html
                showSessionId:"",
                src:""
            }
        }
    }
</script>

<style>
.about{
    width: 100%;
    min-height: 700px;
    margin-top: 83px;
    display: block;
}
</style>